<template>
  <div>
    <editor ref="editor" :key="editorKey" api-key='9g1lfwefv03ilretqifxvendgwwqvdn2c17w9110vtttaxex' :init="editorConfig" v-model="text" />

    <div
      :style="{'background-image':'url(' + image + ')'}"
      class="elevator-buttons mt-4">

      <textarea
        class="button-textarea left-button"
        data-limit-rows="true"
        :disabled="!(isButton && isLeft)"
        v-model="leftButton"
        maxlength="50"
        rows="3" />

      <textarea
        class="button-textarea right-button"
        data-limit-rows="true"
        :disabled="!(isButton && !isLeft)"
        v-model="rightButton"
        maxlength="50"
        rows="3" />
    </div>

    <PreviewAds
      ref="preview"
    />

    <input
      class="hidden"
      type="file"
      ref="backgroundImage"
      accept="image/*"
      @change="insertBackground"
    />

    <input
      class="hidden"
      type="file"
      ref="insertImage"
      accept="image/*"
      @change="insertContentImage"
    />

  </div>
</template>

<script>
import EditorConfig from './tiny-config'
import html2canvas from 'html2canvas';
import PreviewAds from '@/modules/display/views/editor/form/PreviewAds';
import {ruleMaxFileSize} from '@/modules/core/services/rules';
import Utils from '@/modules/core/services/utils';

export default {
  name: 'EditorPanel',
  components: {
    PreviewAds
  },
  props: {
    data: String,
    takenButtonText: String,
    isButton: Boolean,
    isLeft: Boolean
  },
  data() {
    return {
      editorConfig: {},
      text: '',
      image: '',
      buttonText: '',
      background: {},
      sizeLimit: 500000, //500KB
      shownEditorSizeAlert: false,
      filePickerCallbackFn: null,
      leftButton: '',
      rightButton: '',
      editorKey: 0
    }
  },
  watch:{
    data: {
      handler() {
        this.clearAllData();
        this.$refs.editor.editor.setContent(this.data);
        //find background-image information and set it again
        if (this.data.indexOf("background-image: url(") >= 0) {
          var startIndex = this.data.indexOf("background-image: url(") + 28;
          var endIndex = this.data.indexOf(")",startIndex)-6;
          this.setBodyStyle(this.data.substring(startIndex,endIndex));
        }
      }
    },
    isButton() {
      if (!this.isButton) {
        this.leftButton = '';
        this.rightButton = '';
      } else {
        this.leftButton = this.isLeft ? this.buttonText : '';
        this.rightButton = !this.isLeft ? this.buttonText : '';
      }
    },
    isLeft() {
      if (this.isButton) {
        if (this.isLeft) {
          this.leftButton = this.buttonText
          this.rightButton = '';
        } else {
          this.rightButton = this.buttonText
          this.leftButton = '';
        }
      }
    },
    leftButton() {
      if (this.isButton && this.isLeft) {
        this.buttonText = this.leftButton;
      }
    },
    rightButton() {
      if (this.isButton && !this.isLeft) {
        this.buttonText = this.rightButton;
      }
    },
    takenButtonText() {
      this.buttonText = this.takenButtonText;
      if (this.isLeft) {
        this.leftButton = this.buttonText;
      } else {
        this.rightButton = this.buttonText;
      }
    }
  },
  computed: {
    fileSizeLimit() {
      return process.env.VUE_APP_UPLOAD_SIZE_DOCUMENT;
    }
  },
  methods: {
    ruleMaxFileSize,
    addCustomButton(editor) {
      let insertBackground = this.$refs.backgroundImage;
      editor.ui.registry.addButton('insertBackground', {
        text: this.$t('display/editor:editor-panel.insert-background'),
        onAction: function () {
          insertBackground.value = '';
          insertBackground.click();
        }
      });

      editor.ui.registry.addButton('deleteBackground', {
        text: this.$t('display/editor:editor-panel.delete-background'),
        onAction: function () {
          editor.getBody().style.backgroundImage = 'none';
        }
      });

      editor.ui.registry.addButton('previewFunction', {
        icon: 'preview',
        tooltip: this.$t('display/editor:editor-panel.preview'),
        onAction: () => {
          this.previewResult();
        }
      });

      editor.ui.registry.addButton('downloadAsPic', {
        icon: 'browse',
        tooltip: this.$t('display/editor:editor-panel.download-as-picture'),
        onAction: () => {
          this.downloadAsPic();
        }
      });

      editor.ui.registry.addButton('clearAll', {
        icon: 'close',
        tooltip: this.$t('display/editor:editor-panel.remove-all'),
        onAction: () => {
          this.clearAllWindow(editor);
        }
      });

      //Adds indent if tabstop is presed
      editor.on('keyDown', (event) => {

        if(event.which == 9) {
          editor.execCommand('mceInsertContent', false, '&emsp;&emsp;');
          event.preventDefault();
          event.stopPropagation();
          return false;
        }

        if(editor.getContent() == '') {
          this.execCommand("fontName", false, "Arial");
        }
      })

      //when editor gets emptied out, set the font to arial
      //required or else the font would be set to "SYSTEM FONT", which doesn't work in IE
      editor.on('keyUp', () => {

        if(editor.getContent() == '') {
          this.execCommand("fontName", false, "Arial");
        }
      })

    },

    clearAllWindow(editor) {
      editor.windowManager.open({
        title: this.$t('display/editor:editor-panel.attention'),
        body: {
          type: 'panel',
          items: [
            {
              type: 'htmlpanel',
              html: this.$t('display/editor:editor-panel.remove-all-text')
            }
          ]
        },
        buttons: [
          {
            text: "Yes",
            primary: false,
            type: "submit"
          },
          {
            text: "No",
            primary: true,
            type: "cancel"

          }
        ],
        size: 'small',
        //When yes is pressed, clear the editor window
        onSubmit: function (window) {
          this.clearAllData();
          window.close();
        },
      });
    },
    clearAllData() {
      let editor = this.$refs.editor.editor;
      editor.resetContent();
      editor.getBody().style.backgroundImage = 'none';
    },

    downloadAsPic() {
      let body = this.$refs.editor.editor.getBody();

      html2canvas(body, {
        letterRendering: 1,
        allowTaint: false,
        useCORS: true,
        width: 1280,
        height: 720
      }).then((canvas) => {
        var link = document.createElement('a');
        if(canvas.msToBlob) { // FIXED
          body.style.height = "688px";
          window.navigator.msSaveBlob(canvas.msToBlob(), 'testEdge.png');
        } else {
          if (typeof link.download === 'string') {

            link.href = canvas.toDataURL();
            link.download = 'testImage.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            window.open(canvas.toDataURL());
          }
        }
      });
    },
    previewResult() {
      let body = this.$refs.editor.editor.getBody();

      this.$refs.preview.initialization(body);
    },
    setBodyStyle(backgroundImage) {
      let bodyContent = this.$refs.editor.editor.getBody();

      bodyContent.style.width = "1248px";
      bodyContent.style.height = "688px";
      bodyContent.style.margin = 0;
      bodyContent.style.padding = "16px";

      //some browser (IE, Edge) omit data when uploading images, so we have to check them and add the info again
      if(backgroundImage.indexOf("data:") != 0){
        backgroundImage = "data:" + backgroundImage;
      }

      bodyContent.style.backgroundImage = "url('" + backgroundImage.replace(/(\r\n|\n|\r)/gm, "") + "')";
      bodyContent.style.backgroundRepeat = "no-repeat";
      bodyContent.style.backgroundSize = "cover";
    },
    isTypeAcceptable(fileName) {
      let parts = fileName.split('.');
      let extension = parts[parts.length - 1];
      extension = extension.toLowerCase();

      let result = extension === 'jpg'
        || extension === 'jpeg'
        || extension === 'gif'
        || extension === 'bmp'
        || extension === 'png';

      if (!result) {
        Utils.showWarningSnackbar(this.$t('display/editor:editor-panel.extension-not-supported', {extension: extension}));
      }

      return result;
    },
    isSizeAcceptable(size) {
      let result = true;
      if (size > this.sizeLimit) {
        Utils.showWarningSnackbar(this.$t('display/editor:editor-panel.file-size-warning', {size: this.sizeLimit / 1000, unit: 'KB'}));
        result = false;
      }

      return result;
    },
    insertBackground(value) {
      let reader = new FileReader();
      let file = value.target.files[0];
      reader.readAsDataURL(file);

      if (this.isSizeAcceptable(file.size) && this.isTypeAcceptable(file.name)) {
        reader.onloadend = () => {
          this.setBodyStyle(reader.result);
        }
      }
    },
    insertContentImage(value) {
      let file = value.target.files[0];
      let reader = new FileReader();
      let callback = this.filePickerCallbackFn;
      reader.readAsDataURL(file);

      if (this.isSizeAcceptable(file.size) && this.isTypeAcceptable(file.name)) {
        reader.onloadend = function () {
          callback(reader.result);
        }
      }
    },
    filePickerCallback(callback, value, meta) {
      if (meta.filetype === 'image') {
        let insertImageField = this.$refs.insertImage;
        insertImageField.value = '';
        this.filePickerCallbackFn = callback;
        insertImageField.click();
      }
    },
    getPublishData() {
      return {
        content: this.$refs.editor.editor.getBody().outerHTML,
        buttonText: this.buttonText,
        button: this.isButton,
        leftButton: this.isLeft,
        base64ImageData: ''
      }
    },
    generateImage() {
      let self = this;
      html2canvas(this.$refs.editor.editor.getBody(), {
        letterRendering: 1,
        allowTaint: false,
        useCORS: true,
        width: 1280,
        height: 720
      }).then((canvas) => {
        self.$emit('imageReady', canvas.toDataURL('image/png'));
      });
    },
    reInitWysiwyg() {
      this.editorKey++;
    }
  },
  mounted() {
    this.image = require('@/assets/editor/button_frame.png');
    this.leftButton = this.takenButtonText;
    this.editorConfig = Object.assign(EditorConfig,
      {setup: (editor) => { this.addCustomButton(editor)}},
      {file_picker_callback: (callback, value, meta) => { this.filePickerCallback(callback, value, meta);}},
      {language: this.$store.state.translation.language}
    );
  }
}
</script>

<style scoped>
 .elevator-buttons {
   background-repeat: no-repeat;
   background-size: contain;
   box-sizing: border-box;
   height: 180px;
   max-width: 1282px;
  }

 .button-textarea {
   resize: none;
   width: 25vw;
   height: 7.4vw;
   font-size: 1.5vw;
   font-weight: bold;
   background-color: transparent;
   color: white;
   text-align: center;
   padding: 2px 5.5vw;
 }

 .left-button {
   float: left;
 }

 .right-button {
   float: right;
 }

 .hidden {
   display: none;
 }
</style>
